<template>
  <div class="content">
    <p v-html="$gettext('Please upgrade to Premium to get full access.')" />
    <div class="feature-list">
      <p class="feature-list__title">{{ $gettext('Here\'s what you get with Gekko Premium.') }}</p>
      <ul>
        <li class="list-item">
          <div class="list-item__icon"><font-awesome-icon icon="fa-regular fa-circle-check" /></div>
          <div class="list-item__text">
            <p><span v-html="$gettext('Manage <strong>multiple company profiles</strong> with a single account.')" /></p>
          </div>
        </li>
        <li class="list-item">
          <div class="list-item__icon"><font-awesome-icon icon="fa-regular fa-circle-check" /></div>
          <div class="list-item__text">
            <p><span v-html="$gettext('Connect <strong>team members</strong> to your company profile.')" /></p>
          </div>
        </li>
        <li class="list-item">
          <div class="list-item__icon"><font-awesome-icon icon="fa-regular fa-circle-check" /></div>
          <div class="list-item__text">
            <p><span v-html="$gettext('<strong>Custom invoice design</strong>, schedule invoices, foreign valuta, unlimited quotations')" /></p>
          </div>
        </li>
        <li class="list-item">
          <div class="list-item__icon"><font-awesome-icon icon="fa-regular fa-circle-check" /></div>
          <div class="list-item__text">
            <p><span v-html="$gettext('Create <strong>custom cost types</strong>, forward receipts <strong>from your e-mail</strong> etc.')" /></p>
          </div>
        </li>
        <li class="list-item">
          <div class="list-item__icon"><font-awesome-icon icon="fa-regular fa-circle-check" /></div>
          <div class="list-item__text">
            <p><span v-html="$gettext('Generate your <strong>vat</strong> report, <strong>products</strong> report, <strong>revenue reports</strong> per customer etc.')" /></p>
          </div>
        </li>
      </ul>
    </div>
    <p>{{ $gettext('Premium not only gives access to all of this, but also full and unlimited access to all features on Gekko.') }}</p>
  </div>
</template>

<script>
  export default {
    name: "PremiumModalDefaultContent",
  }
</script>

<style lang="scss" scoped>

</style>